"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var main_1 = require("../../themes/main");
var utils_1 = require("../../utils");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var color = _a.color;
            var getColor = function () {
                switch (color) {
                    case 'error':
                        return {
                            color: theme.palette.error.contrastText,
                            backgroundColor: theme.palette.error.main,
                        };
                    case 'secondary':
                        return {
                            color: theme.palette.error.contrastText,
                            backgroundColor: main_1.materialColors.blue[700],
                        };
                    case 'tertiary':
                        return {
                            color: theme.palette.error.contrastText,
                            backgroundColor: main_1.materialColors.grey[700],
                        };
                    case 'success':
                        return {
                            color: '#fff',
                            backgroundColor: theme.palette.success.main,
                        };
                    case 'primary':
                    default:
                        return {
                            color: theme.palette.primary.main,
                            backgroundColor: main_1.materialColors.grey[100],
                        };
                }
            };
            return __assign({ textTransform: 'uppercase', fontWeight: utils_1.textWeightMap['extra-bold'], fontSize: utils_1.textSizeMap.text.small }, getColor());
        },
    });
});
